export default __webpack_public_path__ + "static/checknlearn-promo@2x-c5cc13bc67633f626110a61dcfc6a4c2.jpg";